import { BCMSStateManagerCRUD, useWorkflow } from "@bcm-dev/bcms-vite";
import PageContainer from "components/shared/containers/PageContainer";
import React from "react";
import { ImageAsset } from "res";
import "./styles.css";

/**
 * @function CameraViewPage
 * @return {React.Component}
 * @exported true
 * @description The main component for CameraViewPage
 * @example
 * <CameraViewPage />
 */

export default function CameraViewPage(props) {
  const data = props.data ?? {};
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  const { prevStep } = useWorkflow() ?? {};

  const onCancelClick = evt => prevStep();
  const onPageContainerClick = evt => {
    const view = ui.selectedCheckView === "front" ? "checkFrontView" : "checkBackView";

    BCMSStateManagerCRUD.init({ data, ui })
      .update([ "ui", view, "isSet" ], true)
      .submit(prevStep);
  }

  return (
    <PageContainer className={ `camera-view-page ${ props.className ?? "" }` } onClick={ onPageContainerClick }>
      <div className="check-image-page-content flex-container flex-horizontal align-center">
        <div className="set-width flex-container flex-horizontal align-center capture-directions-container text-rotate">
          <div className="flex-width text-container side-instruction-container">
            <p>Place check on dark surface, align to fit within green guide lines.</p>
          </div>
          <div className="set-width link-container">
            <a className="cancel-link clickable" onClick={ onCancelClick }>Cancel</a>
          </div>
        </div>
        <div className="set-width image-capture-container flex-container flex-horizontal align-center clickable">
          <div className="capture-container" data-point="Camera_View_Check">
            <p className="tap-screen-direction-text text-center">Tap the screen to capture the image.</p>
            <ImageAsset id={ ui.selectedCheckView === "front" ? "CheckFront" : "CheckBack" } className="check-image" />
          </div>
        </div>
        <CameraHeaderView text="Front Check Image" />
      </div>
    </PageContainer>
  );
}

export const getDefaultPageUI = () => ({
  selectedCheckView: "front"
})

/**
 * @function CameraHeaderView
 * @param {STRING} text - Allows us to set the text that is displayed
 * @return {React.Component}
 * @exported true
 * @description This is the header of the CameraViewPage
 * @example
 * <CameraHeaderView text="Front Check Image" />
 */

export function CameraHeaderView(props) {
  const text = props.text ?? "";
  
  return(
    <div className="camera-header-view set-width text-rotate">
      <p>{text}</p>
    </div>
    );
  
}